// extracted by mini-css-extract-plugin
var _1 = "ihf5J";
var _2 = "OHBG_";
var _3 = "On0Ks";
var _4 = "bdVsq";
export { _1 as "attribute", _2 as "base", _3 as "edit", _4 as "emptyValue" }
